import 'css-chunksrc/client/pages/projectPage/timeSheetPage/allocations/allocation/recordList/styles.scss';export default {
  "recordList": "_recordList_10i4y_1",
  "dates": "_dates_10i4y_7",
  "timeOverview": "_timeOverview_10i4y_17",
  "resource": "_resource_10i4y_21",
  "record": "_record_10i4y_1",
  "list": "_list_10i4y_25",
  "task": "_task_10i4y_29",
  "odd": "_odd_10i4y_44",
  "today": "_today_10i4y_47",
  "weekEnd": "_weekEnd_10i4y_50",
  "unAvailable": "_unAvailable_10i4y_53"
};